import { svg } from 'lit';
import { type IconBase, createIconComponent } from '../Icon.component';

/** List of icons here : https://lamaille.supernova-docs.io/latest/foundations/iconography-system-xiZRSP4Z#search-7b7542c0-4d44-11ec-8ce5-cb0f56bcf344 **/
export const IconSmartphone = createIconComponent(
    'lr-icon-smartphone',
    svg`
<path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M7 5V27C7 28.6569 8.34315 30 10 30H22C23.6569 30 25 28.6569 25 27V5C25 3.34315 23.6569 2 22 2H10C8.34315 2 7 3.34314 7 5ZM9 27V5C9 4.44772 9.44772 4 10 4H22C22.5523 4 23 4.44772 23 5V27C23 27.5523 22.5523 28 22 28H10C9.44772 28 9 27.5523 9 27ZM16 25C17.1046 25 18 24.1046 18 23C18 21.8954 17.1046 21 16 21C14.8954 21 14 21.8954 14 23C14 24.1046 14.8954 25 16 25Z" fill="currentcolor"/>
`
);

declare global {
    interface HTMLElementTagNameMap {
        'lr-icon-smartphone': IconBase;
    }
}
